export const appConfig = {
  defaultLocale: 'en' as const,
  i18nDomains: ['common', 'navigation', 'dashboard', 'settings'] as const,
}
